import { render, staticRenderFns } from "./MedicalQuestions.vue?vue&type=template&id=585720a6&scoped=true"
import script from "./MedicalQuestions.vue?vue&type=script&lang=js"
export * from "./MedicalQuestions.vue?vue&type=script&lang=js"
import style0 from "./MedicalQuestions.vue?vue&type=style&index=0&id=585720a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585720a6",
  null
  
)

export default component.exports